module.exports = __webpack_public_path__ + "660f0387571b41f51fdfa16959238914.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/na.svg
// module id = 1506
// module chunks = 1 5 7 8 15 80